"use client";

import React, { useState, useEffect } from "react";
import { useRouter } from "next/navigation";
import { SearchBar } from "oddsgate-ds";
import { useGlobalContext } from "@/lib/globalContext";
import { WpClientRequest } from "@/lib/wordpress/wpClientRequest";

export type IBlockSearchBar = {
  attrs: {
    placeholder?: string;
    initialValue?: string;
  };
};

export default function BlockSearchBar({ attrs }: IBlockSearchBar) {
  const { initialValue, placeholder } = attrs || {};
  const [searchTerm, setSearchTerm] = useState(initialValue || "");
  const [themeOptions, setThemeOptions] = useState<any>(null);
  const [glossaryPageLink, setGlossaryPageLink] = useState<string | null>(null);
  
  const router = useRouter();

  const glossaryRoutes = {
    pt: "/glossario",
    es: "/glosario",
    en: "/glossary",
  };
  const state = useGlobalContext();
  type Lang = "pt" | "es" | "en";
  const lang: Lang = (state?.lang as Lang) || "en";

  useEffect(() => {
    const fetchThemeOptions = async () => {
      try {
          const pageData = await WpClientRequest({
            post_type: "page", 
            variables: {
              lang: lang,
            },
            isContent: true,
          });
            const glossaryTitles = ["glossario", "glossary", "glosario"];
            const glossaryPage = pageData.find(
              (page: any) =>
                glossaryTitles.includes(
                  (page?.title?.rendered || page?.title)?.toString().toLowerCase()
                )
            );
            if (glossaryPage && glossaryPage.slug) {
              setGlossaryPageLink(glossaryPage.slug);
            }
          
      } catch (error) {
        console.error("Error fetching theme options:", error);
      }
    };

    fetchThemeOptions();
  }, []);

  const handleSearch = () => {
    if (searchTerm.trim()) {
      router.push(
        `${glossaryRoutes[lang]}?search=${encodeURIComponent(searchTerm.trim())}`
      );
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <SearchBar
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      placeholder={state.dict?.glossary?.searchPlaceholder || "Procurar..."}
      onClick={handleSearch}
      onKeyDown={handleKeyDown}
    />
  );
}
